
import { defineComponent } from 'vue'
import { iBusinessModel } from '../Metaweb'
import { AxiosResponse } from 'axios'
import mainDescriptor from '../MetawebDescriptor.json'
import KnFabButton from '@/components/UI/KnFabButton.vue'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import bmDescriptor from './MetawebBusinessModelDescriptor.json'
import Menu from 'primevue/contextmenu'
import MetawebBusinessPropertyListTab from './tabs/propertyListTab/MetawebBusinessPropertyListTab.vue'
import BusinessClassDialog from './dialogs/MetawebBusinessClassDialog.vue'
import BusinessViewDialog from './dialogs/MetawebBusinessViewDialog.vue'
import MetawebAttributesTab from './tabs/metawebAttributesTab/MetawebAttributesTab.vue'
import InboundRelationships from './tabs/inboundRelationships/MetawebInboundRelationships.vue'
import OutboundRelationships from './tabs/outboundRelationships/MetawebOutboundRelationships.vue'
import MetawebPhysicalTableTab from './tabs/physicalTable/MetawebPhysicalTableTab.vue'
import MetawebJoinRelationships from './tabs/joinRelationships/MetawebJoinRelationships.vue'
import MetawebFilterTab from './tabs/filterTab/MetawebFilterTab.vue'
import CalculatedField from './tabs/calculatedField/MetawebCalculatedField.vue'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Chip from 'primevue/chip'

const { generate, applyPatch } = require('fast-json-patch')

export default defineComponent({
    name: 'metaweb-business-model',
    components: {
        Chip,
        Column,
        DataTable,
        CalculatedField,
        MetawebJoinRelationships,
        OutboundRelationships,
        BusinessClassDialog,
        BusinessViewDialog,
        KnFabButton,
        TabView,
        TabPanel,
        Menu,
        MetawebBusinessPropertyListTab,
        MetawebAttributesTab,
        InboundRelationships,
        MetawebPhysicalTableTab,
        MetawebFilterTab
    },
    props: { propMeta: { type: Object }, observer: { type: Object }, metaUpdated: { type: Boolean }, businessModelId: Number },
    emits: ['loading', 'metaUpdated'],
    computed: {},
    data() {
        return {
            bmDescriptor,
            mainDescriptor,
            meta: null as any,
            menuButtons: [] as any,
            customFunctions: [] as any,
            showBusinessClassDialog: false,
            showBusinessViewDialog: false,
            selectedBusinessModel: {} as iBusinessModel,
            roles: [] as any[],
            loading: false
        }
    },
    watch: {
        propMeta() {
            this.loadMeta()
        },
        metaUpdated() {
            this.loadMeta()
        }
    },
    created() {
        this.loadMeta()
        this.createMenuItems()
        this.loadRoles()
        this.loadCustomFunctions()
    },
    methods: {
        showMenu(event) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.optionsMenu.toggle(event)
        },
        createMenuItems() {
            this.menuButtons = []
            this.menuButtons.push({ key: '0', label: this.$t('metaweb.businessModel.newBusiness'), command: () => this.showBusinessClass() }, { key: '1', label: this.$t('metaweb.businessModel.newView'), command: () => this.showBusinessView() })
        },
        loadMeta() {
            this.meta = this.propMeta
        },
        selectBusinessModel(event) {
            this.selectedBusinessModel = event.data as iBusinessModel
        },
        showBusinessClass() {
            this.showBusinessClassDialog = true
        },
        showBusinessView() {
            this.showBusinessViewDialog = true
        },
        async deleteFromList(itemForDeletion) {
            const postData = { data: { name: itemForDeletion.uniqueName }, diff: generate(this.observer) }
            let url = ''
            itemForDeletion.joinRelationships ? (url = process.env.VUE_APP_META_API_URL + '/1.0/metaWeb/deleteBusinessView') : (url = process.env.VUE_APP_META_API_URL + '/1.0/metaWeb/deleteBusinessClass')
            await this.$http
                .post(url, postData)
                .then((response: AxiosResponse<any>) => {
                    this.meta = applyPatch(this.meta, response.data).newDocument

                    this.$store.commit('setInfo', {
                        title: this.$t('common.toast.deleteTitle'),
                        msg: this.$t('common.toast.deleteSuccess')
                    })
                    generate(this.observer)
                })
                .catch(() => {})
        },
        async loadRoles() {
            this.loading = true
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '2.0/roles').then((response: AxiosResponse<any>) => (this.roles = response.data))
            this.loading = false
        },
        async loadCustomFunctions() {
            this.loading = true
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/configs/KNOWAGE.CUSTOMIZED_DATABASE_FUNCTIONS/${this.businessModelId}`).then((response: AxiosResponse<any>) => {
                if (response.data.data && response.data.data.length > 0) {
                    this.customFunctions = response.data.data.map((funct) => ({ category: 'CUSTOM', formula: funct.value, label: funct.label, name: funct.name, help: 'dataPreparation.custom' }))
                } else this.customFunctions = null
            })
            this.loading = false
        },
        async onRowReorder(event: any) {
            this.loading = true
            const postData = { data: { index: event.dragIndex, direction: event.dropIndex - event.dragIndex }, diff: generate(this.observer) }
            await this.$http
                .post(process.env.VUE_APP_META_API_URL + `/1.0/metaWeb/moveBusinessClass`, postData)
                .then((response: AxiosResponse<any>) => {
                    this.meta = applyPatch(this.meta, response.data).newDocument
                })
                .catch(() => {})
                .finally(() => generate(this.observer))
            this.loading = false
        }
    }
})
